<template>
	<div class="video-card">
		<div class="placeholder" v-if="loading">

		</div>

		<template v-else>
			<div class="frame">
				<iframe class="video" :src="embedURL" frameborder="0" allowfullscreen></iframe>
			</div>

			<div class="text">
				<!-- <div class="date">{{ data.date | moment('D MMM Y') }}, {{ authorName }}</div> -->
				<div class="title">{{ video.title }}</div>

				<div class="excerpt" v-html="video.description"></div> 

				<div class="tags" v-if="video.tags && video.tags.length">
					<div v-for="tag in video.tags" :key="tag" class="tag">{{ tag }}</div>
				</div>
			</div>
		</template>
	</div>
</template>

<script>
export default {
	name: 'video-card',

	props: {
		video: {
			type: Object,
			required: true
		}
	},

	data() {

		return {
			loading: false
		}
	},

	computed: {
		/**
		 * 
		 */
		embedURL() {

			return 'https://www.youtube.com/embed/' + this.video.id
		}
	}
}
</script>

<style lang="stylus" scoped>
.video-card
	background-color dark

	position relative

	@media (max-width: unit(768, px))
		margin-bottom 2em

	.frame
		position relative
		
		padding-bottom 56.25%

		.video
			width 100%
			height 100%

			position absolute
			z-index 1

	.text
		padding 1em

		.date
			color secondary

			font-size 0.8em

		.title
			margin 0.5em auto

			color primary

			font-size 1.6em
			font-weight bold

			&:before
				

				margin-right 0.5em

				font-size 1.2em
		
		.content
			white-space normal
		
		.tags
			display flex
			align-content center
			flex-wrap wrap

			margin 1em auto

			&.float
				width 100%

				position absolute
				bottom 0
			&:not(.float)
				opacity 1

			.tag
				margin 0.4em
				padding 0.4em
				border-radius 0.4em

				background-color secondary
				color light

				font-family fontSans
				font-size 0.8em
				font-weight bold
</style>
